/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  contain: layout;
  display: block;
  min-width: max-content;
  content-visibility: auto;
  contain-intrinsic-size: auto var(--row-height, var(--nve-ref-size-900));
}

[internal-host] {
  grid-auto-columns: var(--grid-auto-columns);
  border-bottom: var(--border-bottom);
  display: grid;
  grid-auto-flow: var(--grid-auto-flow);
  grid-template-columns: var(--grid-template-column);
}

:host(:hover) ::slotted(nve-grid-cell) {
  --interaction-state-ratio: var(--nve-sys-interaction-state-ratio-hover);
}

:host(:state(selected)) ::slotted(nve-grid-cell) {
  --background: var(--nve-sys-interaction-highlighted-muted-background);
  --interaction-state-ratio: var(--nve-sys-interaction-state-ratio-selected);
}
